// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/menu.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.legend-menu {
    width: 27px;
    height: 27px;
    background: #fff;
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}

.icon-menu {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.menu-drop-list {
    width: max-content;
    max-width: 155px;
    background: #fff;
}

.menu-el-wrap {
    display: flex;
    background: #F5F0F5;
}

.dropdown-list {
    min-width: 155px;
    max-height: 110px;
    overflow-y: scroll;
    border: 1px solid #9D9C9D;
    background: #F5F0F5;
}

.menu-list-text {
    padding: 5px;
    text-align: center;
}

.visible {
    background-color: #D0D0D0 !important;
}

.visible svg {
    fill: #000 !important;
}

.menu-checkbox {
    padding: 5px;
    background-color: #F5F0F5;
}

    .menu-checkbox svg {
        fill: #9D9C9D;
    }
`, "",{"version":3,"sources":["webpack://./src/controls/legend/menu/menu.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,gDAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;IAEI;QACI,aAAa;IACjB","sourcesContent":[".legend-menu {\r\n    width: 27px;\r\n    height: 27px;\r\n    background: #fff;\r\n    z-index: 1000;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    cursor: pointer;\r\n}\r\n\r\n.icon-menu {\r\n    content: url('../assets/menu.svg');\r\n}\r\n\r\n.menu-drop-list {\r\n    width: max-content;\r\n    max-width: 155px;\r\n    background: #fff;\r\n}\r\n\r\n.menu-el-wrap {\r\n    display: flex;\r\n    background: #F5F0F5;\r\n}\r\n\r\n.dropdown-list {\r\n    min-width: 155px;\r\n    max-height: 110px;\r\n    overflow-y: scroll;\r\n    border: 1px solid #9D9C9D;\r\n    background: #F5F0F5;\r\n}\r\n\r\n.menu-list-text {\r\n    padding: 5px;\r\n    text-align: center;\r\n}\r\n\r\n.visible {\r\n    background-color: #D0D0D0 !important;\r\n}\r\n\r\n.visible svg {\r\n    fill: #000 !important;\r\n}\r\n\r\n.menu-checkbox {\r\n    padding: 5px;\r\n    background-color: #F5F0F5;\r\n}\r\n\r\n    .menu-checkbox svg {\r\n        fill: #9D9C9D;\r\n    }\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
